"use client"

import {
  Command,
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/Components/ui/command"
import React from "react"
import { useNavigate } from "react-router-dom"
import { AppContext } from "@/App"
import { useCommandMenu } from "@/hooks/useCommandMenu"

export function CommandMenu() {
  const app = React.useContext(AppContext)
  const { openDemoProjectDialog, DemoProjectDialog } = useCommandMenu()

  const [open, setOpen] = React.useState(false)
  const navigate = useNavigate();

  React.useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "j" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault()
        setOpen((open) => !open)
      }
    }
    document.addEventListener("keydown", down)
    return () => document.removeEventListener("keydown", down)
  }, [])

  const handleNavigate = (to: string) => {
    setOpen(false);
    navigate(to);
  }

  const handleNavigateWithTabs = (to: string, tab: string) => {
    setOpen(false);
    navigate(to, { state: { tab: tab } });
  }

  const handleAddDemoProject = () => {
    setOpen(false);
    // Delay opening the dialog to allow command menu to close first
    setTimeout(() => {
      openDemoProjectDialog();
    }, 100);
  }

  return (
    <>
    <CommandDialog open={open} onOpenChange={setOpen}>
      <Command
        filter={(value, search) => {
          if (value.toLowerCase().includes(search)) return 1
          return 0
        }}
      >
        <CommandInput placeholder="Type a command or search..." />
        <CommandList>
          <CommandEmpty>No results found.</CommandEmpty>
          <CommandGroup heading="Dashboard">
            <CommandItem onSelect={() => handleNavigate("/")}>Overview</CommandItem>
            <CommandItem onSelect={() => handleNavigate("/StatusReports")}>Status Reports</CommandItem>
            {app.authLevel >= 2 && (
              <CommandItem onSelect={() => handleNavigate("/UpcomingDeliverables")}>Upcoming Deliverables</CommandItem>
            )}
          </CommandGroup>
          <CommandGroup heading="Project">
            <CommandItem value="Charter" onSelect={() => handleNavigate("/Charter")}>Charter</CommandItem>
            {app.authLevel >= 2 && (
              <><CommandItem value="Plan" onSelect={() => handleNavigate("/Plan")}>Plan</CommandItem>
                <CommandItem value="Risks" onSelect={() => handleNavigate("/Risks")}>Risks</CommandItem>
                <CommandItem value="Actions" onSelect={() => handleNavigate("/Actions")}>Actions</CommandItem>
                <CommandItem value="Issues" onSelect={() => handleNavigate("/Issues")}>Issues</CommandItem>
                <CommandItem value="Decisions" onSelect={() => handleNavigate("/Decisions")}>Decisions</CommandItem>
                <CommandItem value="Support Requests" onSelect={() => handleNavigate("/SupportRequests")}>Support Requests</CommandItem>
                <CommandItem value="Team" onSelect={() => handleNavigate("/Team")}>Team</CommandItem></>
            )}
          </CommandGroup>
          <CommandGroup heading="Reports">
            <CommandItem onSelect={() => handleNavigate("/Reports")}>Reports</CommandItem>
          </CommandGroup>
          <CommandGroup heading="Settings">
            {app.authLevel === 5 && (
              <>
                {/* <CommandItem onSelect={() => handleNavigateWithTabs("/Settings", "company")}>Company Details</CommandItem>
                <CommandItem onSelect={() => handleNavigateWithTabs("/Settings", "companySettings")}>Company Settings</CommandItem> */}
                <CommandItem onSelect={() => handleNavigateWithTabs("/Settings", "users")}>Users</CommandItem>
                <CommandItem onSelect={() => handleNavigateWithTabs("/Settings", "lockManager")}>Lock Manager</CommandItem>
                </>
            )}
            {/* {app.authLevel >= 4 && (
                <CommandItem onSelect={() => handleNavigateWithTabs("/Settings", "reporting")}>Report Settings</CommandItem>
            )} */}
            <CommandItem onSelect={() => handleNavigateWithTabs("/Settings", "userPreferences")}>Preferences</CommandItem>
            <CommandItem onSelect={() => handleNavigateWithTabs("/Settings", "userLogin")}>User Login</CommandItem>
          </CommandGroup>
          <CommandGroup heading="Training">
            <CommandItem onSelect={() => handleNavigateWithTabs("/Training", "menu")}>Training - Menu</CommandItem>
            <CommandItem onSelect={() => handleNavigateWithTabs("/Training", "charter")}>Training - Charter</CommandItem>
            <CommandItem onSelect={() => handleNavigateWithTabs("/Training", "plan")}>Training - Plan</CommandItem>
            <CommandItem onSelect={() => handleNavigateWithTabs("/Training", "risk")}>Training - Risk</CommandItem>
            <CommandItem onSelect={() => handleNavigateWithTabs("/Training", "action")}>Training - Action</CommandItem>
            <CommandItem onSelect={() => handleNavigateWithTabs("/Training", "issue")}>Training - Issue</CommandItem>
            <CommandItem onSelect={() => handleNavigateWithTabs("/Training", "decision")}>Training - Decision</CommandItem>
            <CommandItem onSelect={() => handleNavigateWithTabs("/Training", "support")}>Training - Support</CommandItem>
          </CommandGroup>
          {app.authLevel === 5 && (
            <CommandGroup heading="Admin">
              <CommandItem onSelect={handleAddDemoProject}>Add Demo Project</CommandItem>
            </CommandGroup>
          )}
        </CommandList>
      </Command>
    </CommandDialog>
    <DemoProjectDialog />
    </>
  )
}
